export default __webpack_public_path__ + "static/media/PrivacyPolicyHtml.12583449.txt";